import { defineStore } from 'pinia'
import { ref, type Component } from 'vue'
import { type ApiResponseError } from './ApiResponseError'
import type { BaseActionWithClick } from '@gat-ship/types'
import type { AppError } from './AppError'

export interface ErrorToast {
  id: string
  title: string
  description: string
  actions?: (BaseActionWithClick & { variant?: 'outline' | 'default' })[]
}

export const useApiErrorStore = defineStore('gs-api-error-store', () => {
  const errors = ref<unknown[]>([])

  const apiErrors = ref<ApiResponseError<unknown>[]>([])

  function newApiError(error: ApiResponseError<unknown>) {
    apiErrors.value.push(error)
  }

  function handleApiError(error: ApiResponseError<unknown>) {
    const index = apiErrors.value.findIndex((e) => e === error)
    if (index !== -1) {
      apiErrors.value.splice(index, 1)
    }
  }

  const appErrors = ref<AppError[]>([])

  function newAppError(error: AppError) {
    appErrors.value.push(error)
  }

  function handleAppError(error: AppError) {
    const index = appErrors.value.findIndex((e) => e.message === error.message)
    if (index !== -1) {
      appErrors.value.splice(index, 1)
    }
  }

  const errorToasts = ref<ErrorToast[]>([])

  function showToast(params: ErrorToast) {
    errorToasts.value.push(params)
  }

  return {
    errors,
    apiErrors,
    errorToasts,
    showToast,
    newAppError,
    handleAppError
  }
})
